import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();
const multipartHeaders = { headers: { 'Content-Type': 'multipart/form-data' } };

export async function getMaintenanceDailyList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = query ? `${apiBaseUrl}/maintenance_daily/?${query}` : `${apiBaseUrl}/maintenance_daily/`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getMaintenanceDailyDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_daily/${id}/`).then((r) => r.data);
}

export function createMaintenanceDaily(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/maintenance_daily/`, payload).then((r) => r.data);
}

export function updateMaintenanceDaily(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/maintenance_daily/${id}/`, payload).then((r) => r.data);
}

export function cancelMaintenanceDaily(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/maintenance_daily/${id}/`, {}).then((r) => r.data);
}

export function deleteMaintenanceDaily(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/maintenance_daily/${id}/`).then((r) => r.data);
}

export async function getMaintenanceAutofill(cookies, plantId, logDate, sources = 'plant,pump,transit_mixer') {
    const query = new URLSearchParams({ plant_id: plantId, log_date: logDate, sources }).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_daily/autofill/?${query}`).then((r) => r.data);
}

export async function getMaintenanceReport(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_daily/report/?${query}`).then((r) => r.data);
}

export async function getMaintenanceMonthlyCostList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = query ? `${apiBaseUrl}/maintenance_monthly_cost/?${query}` : `${apiBaseUrl}/maintenance_monthly_cost/`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getMaintenanceMonthlyCostDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_monthly_cost/${id}/`).then((r) => r.data);
}

export function createMaintenanceMonthlyCost(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/maintenance_monthly_cost/`, payload).then((r) => r.data);
}

export function updateMaintenanceMonthlyCost(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/maintenance_monthly_cost/${id}/`, payload).then((r) => r.data);
}

export function cancelMaintenanceMonthlyCost(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/maintenance_monthly_cost/${id}/`, {}).then((r) => r.data);
}

export function deleteMaintenanceMonthlyCost(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/maintenance_monthly_cost/${id}/`).then((r) => r.data);
}

export async function getMaintenanceServiceList(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    const url = query ? `${apiBaseUrl}/maintenance_service/?${query}` : `${apiBaseUrl}/maintenance_service/`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getMaintenanceServiceDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_service/${id}/`).then((r) => r.data);
}

export function createMaintenanceService(cookies, formData) {
    return getApiClient(cookies).post(`${apiBaseUrl}/maintenance_service/`, formData, multipartHeaders).then((r) => r.data);
}

export function updateMaintenanceService(cookies, id, formData) {
    return getApiClient(cookies).put(`${apiBaseUrl}/maintenance_service/${id}/`, formData, multipartHeaders).then((r) => r.data);
}

export function cancelMaintenanceService(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/maintenance_service/${id}/`, {}).then((r) => r.data);
}

export function deleteMaintenanceService(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/maintenance_service/${id}/`).then((r) => r.data);
}

export async function getMaintenanceServiceAlerts(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_service/alerts/?${query}`).then((r) => r.data);
}

export async function getEquipmentMeter(cookies, equipmentId) {
    return getApiClient(cookies).get(`${apiBaseUrl}/maintenance_service/equipment_meter/?equipment_id=${equipmentId}`).then((r) => r.data);
}
